import React from "react";
import params from "../Params";
import harrenhal from "../Harrenhal";
import {HW_DRIVER_URL} from "../Const";

const LOCAL_SERVER = 'http://localhost:12346';

function withSimGpsHwController(WrappedComponent){

    return class extends React.Component {

        constructor(props) {
            super(props);

            const useLocalIfServer = true;

            let urls =  {
                sim_init: params.SIM_INIT_URL,
                sim_update: params.SIM_UPDATE_URL,
            };

            if (useLocalIfServer) {
                urls={
                    sim_init : LOCAL_SERVER + '/sim_init.json',
                    sim_update : LOCAL_SERVER + '/Test/sim_data',
                };
            }

            this.state = {
                urls: urls,
                timer: null,
                isDriverConfigured: false,
                harrenhal_ver: null,
                simGpsHwState: 'unknown',
            };
        }

        updateHwStatus = () => {
            let req_headers = new Headers();
            req_headers.append('Content-Type', 'application/json');
            let  data;

            if( this.state.isDriverConfigured){  // Just query the state
                data = {
                    command: 'get_status',
                    params: null
                };
            }else{  // POST configuration parameters
                console.log('Pushing  parameters to local server');

                let if_init_url = this.state.urls.sim_init;
                let if_update_url = this.state.urls.sim_update;
                let client_config = {
                    id_token: this.props.id_token,
                    api_key: params.PENTOS_API_KEY,
                    if_init_url: if_init_url,
                    if_update_url: if_update_url
                };

                data = {
                    command: 'config',
                    params: client_config
                };
            }

            let req_init = {
                method: 'POST',
                headers: req_headers,
                body: JSON.stringify(data),
                mode: 'cors',
                cache: 'default'
            };
            this.doFetch(req_init);

        };

        doFetch = (req_init) => {
            fetch(HW_DRIVER_URL, req_init)
                .then(res => res.json())
                .then(
                    (result) => {
                        console.log(result);
                        this.setState({
                            isDriverConfigured: result.configured,
                            simGpsHwState: result.state,
                            harrenhal_ver: result.ver,
                            sess_uuid: result.sess_uuid,

                            registration_done: result.registration_done,
                            registration_ok: result.registration_ok,
                        });
                    },
                    // Note: it's important to handle errors here
                    // instead of a catch() block so that we don't swallow
                    // exceptions from actual bugs in components.
                    (error) => {
                        console.log('Error talking to HW driver: ' + error);
                        this.setState({
                            isDriverConfigured: false
                        });
                    }
                )
        };

        componentDidMount() {
            let timer = setInterval(this.updateHwStatus, 1000);
            this.setState({
                timer: timer,
            });
        }

        // This method is called by React
        componentWillUnmount() {
                clearInterval(this.state.timer);
        }

        render () {
            let hwStatus='';
            let harrenhalDownloadLink = process.env.PUBLIC_URL + harrenhal.HARRENHAL_LINK;
            if(this.state.isDriverConfigured){
                // Check the Harrenal version
                if( this.state.harrenhal_ver === harrenhal.HARRENHAL_VER){
                    if(this.state.simGpsHwState === 'idle') {
                        hwStatus = <div>
                            The Riverrun board is not detected. Please verify if it plugged in to USB
                        </div>;
                    }
                }else{
                    hwStatus = <div>You have incorrect version of Harrenhal running on your computer.
                        The required version is {harrenhal.HARRENHAL_VER}, but you have {this.state.harrenhal_ver}
                        <br/>
                        Use  <a href={harrenhalDownloadLink}> this link to download and install version {harrenhal.HARRENHAL_VER} </a> once downloaded, start it.
                    </div>;
                }
            }else{
                hwStatus = <div>Connecting to HW bridge application... If you see that message most likely it's not running.
                    Use  <a href={harrenhalDownloadLink}> this link to download and install it </a> once downloaded, start it.
                </div>;
            }

            return <div>
                {hwStatus}
                <WrappedComponent {...this.props}
                                  simGpsHwState={this.state.simGpsHwState}
                                  registration_done={this.state.registration_done}
                                  registration_ok={this.state.registration_ok}
                />
            </div>
        }
    }
}

export default withSimGpsHwController;
